export const environment = {
  production: false,
  // baseUrl: "http://localhost:7072/api",
  baseUrl: "https://nbl-yms-serverless-dev.azurewebsites.net/api",
  config_fn_code: "zideqmlzqWo0vErSeKN4Bsej35l6hXOnk7KuBbZFs4QoAzFurijiTA==",
};
